import { Game } from './Game';
import { setBootStatus } from './ui/Boot';
import { Hud } from './ui/Hud';

Hud.mount();
setBootStatus('Waking Vesper Cay…');

void (async () => {
  try {
    const game = await Game.boot((msg) => setBootStatus(msg));
    await game.warm((msg) => setBootStatus(msg));
    setBootStatus('Click Start', true);
  } catch (err) {
    const text = err instanceof Error ? err.message : 'Boot failed';
    setBootStatus(text, false);
    throw err;
  }
})();
